import { Pipe, PipeTransform } from "@angular/core";
import { formatCurrency } from "@ponder-shared/utils/numberFormatter";

@Pipe({
    name: 'currency',
    standalone: true
})
export class FormatCurrencyPipe implements PipeTransform {
    constructor() {

    }

    public transform(value: string | number, type?: string) {
        if (!type) {
            return formatCurrency(+value);
        } else {
            switch (type) {
                // leave room for non-usd formatting
                case 'usd':
                default:
                    return formatCurrency(+value);
            }
        }
    }
}